import { RootState } from '@redux/store';

const help = (state: RootState) => state.help;

export const getChapters = (state: RootState) => help(state).chapters;

export const getChapterType = (state: RootState) => help(state).chapterType;
